import { render, staticRenderFns } from "./LoaLevel.vue?vue&type=template&id=71835b13"
import script from "./LoaLevel.vue?vue&type=script&lang=js"
export * from "./LoaLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports